import { EndpointBuilder } from '@reduxjs/toolkit/query/react';
import { Customer, Discount } from './types';
import { ApiBaseQuery, ApiTagTypes } from '../types';
import { UpdateCustomerRequest } from './types';

/**
 * Endpoints для работы с клиентом
 */
export const customerEndpoints = (builder: EndpointBuilder<ApiBaseQuery, ApiTagTypes, 'api'>) => ({
    /**
     * Получение текущего клиента (из кеша после логина)
     */
    getCustomer: builder.query<Customer, void>({
        query: () => ({
            url: '/private/customer',
        }),
        transformResponse: (response: Customer): Customer => {
            const discountsForPeriods: Discount[] = response.discounts_for_periods.map((val) => {
                // Конвертируем в проценты: 0.9 -> 10%
                const discountPercent = (1 - val.discount) * 100;
                const discount = Math.round(discountPercent * 100) / 100; // Округляем до 2 знаков
                return {
                    months: val.months,
                    discount: discount,
                    percentOfAmount: val.discount,
                };
            });

            // Инвертируем баланс (API возвращает отрицательное значение для долга)
            return {
                ...response,
                balance: -response.balance,
                status: response.status ?? 'regular',
                language: response.language === 'pl' ? 'nl' : response.language,
                discounts_for_periods: discountsForPeriods,
            };
        },
        providesTags: ['Customer'],
    }),
    /**
     * Обновление данных клиента
     */
    updateCustomer: builder.mutation<void, UpdateCustomerRequest>({
        query: (body) => ({
            url: '/private/customer',
            method: 'PUT',
            body,
        }),
    }),
});
